import {combineReducers} from "redux";
import {option} from "./option";
import {exercise} from "./exercise";

export const rootReducer =  combineReducers({
    option,
    exercise
});